import React, { useEffect, useState } from "react";
import {Button, Checkbox, Select, Tooltip} from "antd";
import "./index.less";
import { LightningSearchTypeEnum } from "@/util/cosntants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import { updateIsRefresh, updateSearchType } from "@/redux/actions/lightningAction";

import { updateCurrentStage } from "@/redux/actions/weevilTrakAction";
import { InfoCircleOutlined } from "@ant-design/icons";



const WeevilTrakStage = () => {

    const stagesData = useSelector((state: RootState) => state.weevTrakReducer.stagesData);
    const currentStage = useSelector((state: RootState) => state.weevTrakReducer.currentStage);
    const dispatch = useDispatch();

    const publicChangeCurrentStage = (value: string) => {
        // const selectedStages = currentStage ?? [];
        // const hasStage = selectedStages.includes(value);
        // // Enforce single-selection while still passing an array for compatibility
        // const nextStages = hasStage ? [] : [value];

        dispatch(updateCurrentStage(value));
    };


    return (
        <div className="weevilTrak-stage">
            <div className="weevilTrak-stage__title">
                <span>Stage <Tooltip
                    overlayStyle={{ maxWidth: "none" }}
                    overlayInnerStyle={{
                        backgroundColor: "#fff",
                        color: "#000",
                        width: "560px",
                        border: "1px solid white",
                        paddingLeft: "20px",
                        cursor: "pointer",
                        fontFamily: "Noto-Sans-Regular"
                    }}
                    title={
                        <span>
                            Stage 1: Peak Activity of Overwintered Adults; <br/>
                            Stage 2: Peak Activity of Early Instar (inside of the stem); <br/>
                            Stage 3: Peak Acitivity of Asynchronous Larvae (inside and outside of the stem);<br/>
                        </span>
                    }
                >
                    <InfoCircleOutlined
                        // style={{ color: "rgba(0,0,0,0.45)" }}
                    />
                </Tooltip></span>
            </div>
            <div className="weevilTrak-stage__content">
                {
                    stagesData?.filter((_,index) => index < 3)?.map((item)=>{
                        const isActive = (currentStage ?? []).includes(item.value);

                        return(
                            <span key={item.value} className={`stage-item ${isActive ? "stage-item-active" : ""} `}
                                onClick={()=>{
                                    publicChangeCurrentStage(item.value);
                                }}
                            >{item.text}</span>
                        );
                    })
                }

            </div>

        </div>
    );
};

export default WeevilTrakStage;